"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FilterNavContent;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _categorySection = _interopRequireDefault(require("./category-section"));
var _siteSearchContext = require("./site-search-context");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CategorySectionsWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CategorySectionsWrapper",
  class: "pl-c28tuqb"
});

/**
 * FilterNav Component.
 *
 * @param {Object} props React props
 * @param {String} props.sections All sections content
 * @returns {React.ReactElement} FilterNavContent Component
 * @public
 */
function FilterNavContent({
  sections
}) {
  const {
    activeFilter,
    results
  } = (0, _react.useContext)(_siteSearchContext.SiteSearchContext);
  const [currentSections, setCurrentSections] = (0, _react.useState)([]);
  (0, _react.useEffect)(() => {
    if (!results || !sections || !Array.isArray(sections)) return;
    const updatedSections = activeFilter === 'all' ? sections.filter(section => results[section.sectionKey]?.length > 0 || section.sectionKey === 'domain') : [sections.find(section => section.sectionKey === activeFilter)].filter(Boolean);
    setCurrentSections(updatedSections);
  }, [activeFilter, results, sections]);
  return /*#__PURE__*/_react.default.createElement(CategorySectionsWrapper, null, currentSections.map(section => /*#__PURE__*/_react.default.createElement(_categorySection.default, (0, _extends2.default)({
    key: section.id
  }, section))));
}
FilterNavContent.propTypes = {
  sections: _propTypes.default.array,
  activeKey: _propTypes.default.oneOf(['all', 'help', 'resources', 'products']),
  setSelectedFilter: _propTypes.default.func
};